/** Фонові списки не опитуємо; при поверненні відразу перевіряємо зміни. */
export function pollVisible(load: () => void | Promise<void>, delay: number): () => void {
  const tick = (): void => {
    if (!document.hidden) void load();
  };
  tick();
  const timer = setInterval(tick, delay);
  document.addEventListener('visibilitychange', tick);
  return () => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', tick);
  };
}
